import { BankIcon, BodyCopy, Button } from "lola-framework-ui-test";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../../store/globalState";
import { useSessionStore } from "../../../../store/useSessionStore";

export interface DestinationAccountInfoProps {
  onClose: () => void;
}

export const DestinationAccountInfo: React.FC<DestinationAccountInfoProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const { session } = useSessionStore();
  const colorConfig = theme.whiteView;
  const {
    backgroundBtn,
    textColorBtn,
    bodyCopy,
    buttonShowIcon,
    buttonSize,
  } = colorConfig;

  const partnerName = session.data?.partner?.name || "Partner";

  return (
    <section className="destination-info-slot">
      <section className="destination-info-icon bg-transparent">
        <BankIcon size={72} />
      </section>
      <BodyCopy as="h2" className="highlight text-center">
        <b>{t("destination.title")}</b>
      </BodyCopy>
      <BodyCopy
        as="h3"
        className="destination-info-subtitle"
        style={{ color: bodyCopy }}
      >
        {t("destination.cannotChange")}
      </BodyCopy>
      <BodyCopy style={{ color: bodyCopy }}>
        {t("destination.explanation", { partner: partnerName })}
      </BodyCopy>
      <Button
        size={buttonSize ?? "small"}
        showIcon={buttonShowIcon}
        background={backgroundBtn}
        color={textColorBtn}
        onClick={onClose}
      >
        {t("destination.gotIt")}
      </Button>
    </section>
  );
};
